"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var videos_1 = require("../infra/videos");
var items_1 = require("./items");
var duck = items_1.default("videos", videos_1.videosRepository, videos_1.urlToVideo, { getTrendingItems: videos_1.getTrendingVideos });
exports.actionCreators = duck.actionCreators;
exports.initialState = duck.initialState;
exports.reducer = duck.reducer;
exports.sagas = duck.sagas;
exports.persistent = true;
exports.storeInitializer = duck.storeInitializer;



//////////////////
// WEBPACK FOOTER
// ./src/redux/videos.ts
// module id = 56
// module chunks = 0